module.exports = __webpack_public_path__ + "img/Space-rescue-preview.5e7d88ef.png";